// extracted by mini-css-extract-plugin
export default {"container":"TermsAcceptancePage_container__soJJa","card":"TermsAcceptancePage_card__cdbME","buttons":"TermsAcceptancePage_buttons__Ynf2l"};